import settingsService from '../api';
import { 
  SET_SETTINGS, 
  SET_SYS_PROMPT,
  SET_USER_PROMPT,
  SET_ACCESS,
  SET_MAX_KEYS,
} from './settings.constants';


export const getSettingsTC = () => {
  return async (dispatch) => {
    try {
      const resp = await settingsService.getSettings();

      if (!resp?.data) {
        return;
      }

      const { systemPrompt, userPrompt, access } = resp.data

      dispatch(setSettingsAC(resp.data));
      dispatch(setAccessAC(access));
      dispatch(setSysPromptAC(systemPrompt));
      dispatch(setUserPromptAC(userPrompt));
    } catch (error) {
      console.log(error);
    }
  };
};

export const setSettingsTC = () => {
  return async (dispatch, getState) => {
    try {
      const settingsData = getState()?.settingsData;
      const {systemPrompt, userPrompt, access} = settingsData;
      const allSettings = {systemPrompt, userPrompt, access };

      await settingsService.setSettings(allSettings);
    } catch (error) {
      console.log(error);
    }
  }
}

export const getMaxKeysTC = () => {
  return async (dispatch) => {
    try {
      const maxKeys = +localStorage.getItem("maxCopyKeys")

      if (!maxKeys) {
        return;
      }

      dispatch(setMaxKeysAC(maxKeys));
    } catch (error) {
      console.log(error);
    }
  };
};

//ACTIONS
export const setSettingsAC = (payload) => {
  return {
    type: SET_SETTINGS,
    payload,
  };
};

export const setSysPromptAC = (payload) => {
  return {
    type: SET_SYS_PROMPT,
    payload,
  };
};

export const setUserPromptAC = (payload) => {
  return {
    type: SET_USER_PROMPT,
    payload,
  };
};

export const setAccessAC = (payload) => {
  return {
    type: SET_ACCESS,
    payload,
  };
};

export const setMaxKeysAC = (payload) => {
  return {
    type: SET_MAX_KEYS,
    payload,
  };
};
